import { useStoreContext } from 'features/store';

import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { useServiceModeLive } from 'state/service-mode';
import { isDelivery } from 'utils/service-mode';

export const useDebugToolPosVendor = () => {
  const { store } = useStoreContext();
  const serviceMode = useServiceModeLive();
  const isOneMenu = useEnableUnifiedMenu();

  const posVendor = (store.pos?.vendor ?? '').trim().toLowerCase();
  const storePosVendor = isDelivery(serviceMode) ? `${posVendor}Delivery` : posVendor;

  return {
    storeNumber: store?.number ?? '',
    storePosVendor,
    storeLabel: `Store Number: ${store?.number ?? ''} - ${isOneMenu ? 'One Menu' : storePosVendor}`,
  };
};
